// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zoraSepolia as _zoraSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zoraSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 999999999
 * Chain Name: Zora Sepolia
 * Default Block Explorer: https://sepolia.explorer.zora.energy/
 * Default RPC URL: https://sepolia.rpc.zora.energy
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zoraSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zoraSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zoraSepolia = createCommon({
	..._zoraSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
